app.controller('HomeCtrl', function(){
    console.log("Home controller");
});